import React, { memo } from "react";
import { AppSegmented, type AppSegmentedOption } from "../../../../../../molecules/AppSegmented";
import { BreakdownMode } from "../api";

type BaseRentBreakdownModeToggleProps = {
  value: BreakdownMode;
  onChange: (value: BreakdownMode) => void;
};

export const BREAKDOWN_MODE_OPTIONS: AppSegmentedOption[] = [
  { label: "Billing Line", value: "billingSchedule" },
  { label: "Schedule", value: "paymentSchedule" },
];

const rootStyle: React.CSSProperties = { marginLeft: 10 };

export const BaseRentBreakdownModeToggle = memo((props: BaseRentBreakdownModeToggleProps) => {
  const { value, onChange } = props;

  return (
    <AppSegmented
      style={rootStyle}
      size="small"
      label="View as"
      options={BREAKDOWN_MODE_OPTIONS}
      value={value}
      onChange={onChange}
    />
  );
});
